export const ONE_DAY = 24 * 60 * 60 * 1000;

const dateOnly = { year: 'numeric', month: 'numeric', day: 'numeric' };

export const dateToLocaleString = ({ date, language }) => {
  if (!date) return null

  try {
    return new Date(date).toLocaleString(language, dateOnly)
  } catch {
    return null
  }
}

const defaultDateTimeOptions = { dateStyle: 'short', timeStyle: 'short' }

export const datetimeToLocaleString = (date, language, options = defaultDateTimeOptions) => {
  if (!date) return null

  try {
    return new Intl.DateTimeFormat(language, options).format(new Date(date))
  } catch {
    return null
  }
}
